var map = {
	"./Auth.png": "2089",
	"./GOLDEN.png": "30b8",
	"./PLATINUM.png": "5d78",
	"./SELECT.png": "a937",
	"./SILVER.png": "a44a",
	"./STANDARD.png": "db1e",
	"./notAuth.png": "9985"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "980e";